import axios from "axios";
import { createContext } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ContentCtx = createContext(null);

let cache = null;

export const fetchContent = async (force = false) => {
  if (cache && !force) return cache;
  try {
    const r = await axios.get(`${API}/content`);
    cache = r.data || {};
  } catch {
    cache = {};
  }
  return cache;
};

export const COLOR_VARS = {
  yellow: "var(--sy)",
  magenta: "var(--sm)",
  cyan: "var(--sc)",
  ink: "var(--ink)",
};

export const cv = (c) => COLOR_VARS[c] || c || "#0A0A0A";
